module.exports = __webpack_public_path__ + "static/media/20ECE2.24ee8c0f.jpg";